export default __webpack_public_path__ + "static/media/notification.2b8e4668.svg";